import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { RefreshTokenService } from 'abp-ng2-module';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AppConsts } from '@shared/AppConsts';


// Renews the access token before an API call when its cookie has expired but a refresh token exists.
@Injectable()
export class ExpiredTokenRefreshInterceptor implements HttpInterceptor {
    constructor(private _injector: Injector) { }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (!this.needsRefresh(request)) {
            return next.handle(request);
        }

        // Resolved: RefreshTokenService depends on HttpClient, which depends on the interceptors.
        return this._injector.get(RefreshTokenService).tryAuthWithRefreshToken().pipe(
            switchMap(() => next.handle(request))
        );
    }

    private needsRefresh(request: HttpRequest<unknown>): boolean {
        const apiBaseUrl = AppConsts.remoteServiceBaseUrl;
        return !!apiBaseUrl
            && request.url.startsWith(apiBaseUrl)
            && request.url.indexOf('/api/TokenAuth/') < 0
            && !request.headers.has('Authorization')
            && !abp.auth.getToken()
            && !!abp.auth.getRefreshToken();
    }
}
